import { REPATRIATIONS_TRANSACTIONS_EDIT_REQUEST, REPATRIATIONS_TRANSACTIONS_EDIT_SUCCESS, REPATRIATIONS_TRANSACTIONS_EDIT_FAILURE } from './types/RepatriationsTransactionsEditActionsTypes';

export function putRepatriationsTransactionsEditRequestActionCreator(context,
  newDepartureDateTime,
  newDescription,
  newInboundImpc,
  newInboundOperator,
  newPlannedArrivalDateTime,
  newQuantity,
  newTransactionId) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_EDIT_REQUEST,
    payload: {
      appContext: context,
      params: {
        departureDateTime: newDepartureDateTime,
        description: newDescription,
        inboundImpc: newInboundImpc,
        inboundOperator: newInboundOperator,
        plannedArrivalDateTime: newPlannedArrivalDateTime,
        quantity: newQuantity,
        transactionId: newTransactionId,
      },
    },
  };
}

export function putRepatriationsTransactionsEditSuccessActionCreator(data) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_EDIT_SUCCESS,
    payload: data,
  };
}

export function putRepatriationsTransactionsEditFailureActionCreator(error) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_EDIT_FAILURE,
    payload: error,
    error: true,
  };
}
